<template>
  <p class="price">
    <i18n-t keypath="From {price}" class="lead">
      <template #price>
        <pu-price
          :price="leadPrice"
          :display-original-price="true"
          class="pitch-price"
        />
      </template>
    </i18n-t>
    <span class="pricing-meta">
      <translate :tt="{ nights: leadPriceNights }">
        {nights, plural, one{# night} other{# nights}} </translate
      >,
      <translate v-if="leadPricePersons > 2" :tt="{ people: leadPricePersons }">
        {people} people
      </translate>
      <translate v-else :tt="{ people: leadPricePersons || 2 }">
        {people, plural, one{# adult} other{# adults}}
      </translate>
    </span>
    <small v-if="shouldShowAsterix && excludedPrice" class="pricing-meta">
      <translate>plus taxes or fees</translate>
      <pu-price
        :price="excludedPrice"
        :display-original-price="true"
        class="pitch-price"
      />
    </small>
  </p>
</template>

<script lang="ts">
import type { SimpleMoney } from '~/utility/money'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class PricingPeriodNonDated extends Vue {
  @Prop()
  leadPrice: SimpleMoney

  @Prop()
  leadPriceWithExcluded?: SimpleMoney

  @Prop()
  leadPriceNights: number

  @Prop()
  leadPricePersons: number

  get shouldShowAsterix() {
    return (
      this.leadPriceWithExcluded &&
      this.leadPriceWithExcluded !== this.leadPrice &&
      this.excludedPrice?.amountMinor &&
      this.excludedPrice.amountMinor > 0
    )
  }

  get excludedPrice() {
    if (!this.leadPriceWithExcluded) {
      return null
    }
    return {
      ...this.leadPriceWithExcluded,
      amountMinor:
        this.leadPriceWithExcluded.amountMinor - this.leadPrice.amountMinor,
    }
  }
}

export default toNative(PricingPeriodNonDated)
</script>
<style scoped>
.price {
  color: var(--colour-header-light-blue);
  text-align: right;
  line-height: 1.2;
}

.price :deep(.converted-price) {
  display: none;
}

.lead {
  font-size: var(--body);
}

.pricing-meta {
  color: var(--colour-text-light);
  display: block;
  font-size: var(--tiny);
  font-weight: normal;
  white-space: nowrap;
}
</style>
